/** Fusionne les réponses GET /capitalflow/strategies vers allS / allComp / stratInv. */

export function mergeStrategiesPagePayload(prev, api) {
  if (!api || api.error) return prev;
  const out = {
    allS: prev?.allS ? [...prev.allS] : [],
    allComp: prev?.allComp ? [...prev.allComp] : [],
    stratInv: { ...(prev?.stratInv || {}) },
  };

  const byKey = new Map();
  out.allS.forEach((s) => {
    byKey.set(`${s.name}|${s.analYear}`, s);
  });
  (api.strategies || []).forEach((s) => {
    byKey.set(`${s.name}|${s.analYear}`, s);
  });
  out.allS = Array.from(byKey.values());

  if (api.stratInv && typeof api.stratInv === "object") {
    out.stratInv = { ...out.stratInv, ...api.stratInv };
  }
  (api.links || []).forEach((l) => {
    if (l.strategy && l.investor) out.stratInv[l.strategy] = l.investor;
  });

  const compKey = (c) => `${c.strategy}|${c.symbol}`;
  const compMap = new Map();
  out.allComp.forEach((c) => compMap.set(compKey(c), c));
  (api.constituents || []).forEach((c) => compMap.set(compKey(c), c));
  out.allComp = Array.from(compMap.values());

  return out;
}

export function buildInvestorOverrides(api) {
  const overrides = {};
  (api.investors || []).forEach((inv) => {
    if (!inv.name) return;
    const cur = overrides[inv.name] || {};
    overrides[inv.name] = {
      ...cur,
      ...(inv.style ? { style: inv.style } : {}),
      ...(inv.bio ? { bio: inv.bio } : {}),
      ...(inv.philosophy ? { philosophy: inv.philosophy } : {}),
      ...(inv.ini ? { ini: inv.ini } : {}),
    };
  });
  return overrides;
}
